import { useLazyQuery } from '@apollo/client'

import { GetProductModalBarcodesDocument } from '@/graphql/purchase-plus/generated/getProductModalBarcodes.generated'
import { PURCHASE_PLUS_GRAPHQL_API } from '@/modules/shared/constants'
import { checkNetworkStatus } from '@/modules/shared/utils/checkNetworkStatus'

interface UseGetProductModalBarcodesProps {
  productId: number
}

export const useGetProductModalBarcodes = ({ productId }: UseGetProductModalBarcodesProps) => {
  const [fetchProductModalBarcodes, { data, networkStatus, error, refetch }] = useLazyQuery(
    GetProductModalBarcodesDocument,
    {
      variables: {
        productId,
      },
      context: {
        uri: PURCHASE_PLUS_GRAPHQL_API,
      },
      notifyOnNetworkStatusChange: true,
    }
  )

  const barcodes = data?.product?.barcodes?.unpaginated

  const loadingStates = checkNetworkStatus(networkStatus)

  return {
    fetchProductModalBarcodes,
    error,
    barcodes,
    loadingStates,
    refetch,
  }
}
